const createNumberFromResolution = (format_note: string) => Number(format_note.replace(/\D+/gi, ''));
export default createNumberFromResolution;
